import { render, staticRenderFns } from "./TableLocations.vue?vue&type=template&id=6c9250e3&scoped=true"
import script from "./TableLocations.vue?vue&type=script&lang=ts"
export * from "./TableLocations.vue?vue&type=script&lang=ts"
import style0 from "./TableLocations.vue?vue&type=style&index=0&id=6c9250e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9250e3",
  null
  
)

export default component.exports